import React, { Component } from 'react'
import styles from './Select.module.scss';
import './Select.css';
import classNames from 'classnames/bind';
import ReactSelect from 'react-select';
import {ArrowDownIcon} from '../../atoms';

const cx = classNames.bind(styles);

class Select extends Component {

  onChange = (value, name) => {
    this.props.onChange(name, value);
  }

  onBlur = (name) => {
    this.props.onBlur(name, true);
  }

  render() {
    const { name, options, value, className, isError } = this.props;
    const { onChange, onBlur } = this;

    return (
      <div className={`${className}`}>
        <ReactSelect
          className={cx('Select')}
          classNamePrefix={`${isError && 'Select__Select__inner--error'} Select__Select__inner`}
          components={{DropdownIndicator: ArrowDownIcon}}
          placeholder='——'
          name={name}
          options={options}
          onChange={(value) => onChange(value, name)}
          onBlur={() => onBlur(name)}
          value={value}
        />
      </div>
    )
  }
}

Select.defaultProps = {
  type: 'text',
  name: '',
  placeholder: '',
  className: ''
};

export default Select;
